import api from "@/lib/api";

function hHeader() {
  const hid = typeof document !== "undefined"
    ? document.cookie.split(";").map(c => c.trim()).find(c => c.startsWith("active_hotel_id="))
    : null;
  const val = hid ? decodeURIComponent(hid.split("=")[1]) : null;
  return val ? { "X-Hocp-Hotel": val } : {};
}
const H = () => ({ headers: hHeader() });

export const fnbAPI = {
  dashboard:    ()               => api.get("/fnb/v1/dashboard", H()).then(r => r.data),
  search:       (q)              => api.get("/fnb/v1/search", { ...H(), params: { q } }).then(r => r.data),
  outlets:      ()               => api.get("/fnb/v1/outlets", H()).then(r => r.data),
  serviceLocs:  ()               => api.get("/fnb/v1/service-locations", H()).then(r => r.data),
  categories:   ()               => api.get("/fnb/v1/categories", H()).then(r => r.data),
  createCategory: (body)         => api.post("/fnb/v1/categories", body, H()).then(r => r.data),
  menuItems:    (params={})      => api.get("/fnb/v1/menu-items", { ...H(), params }).then(r => r.data),
  createMenuItem: (body)         => api.post("/fnb/v1/menu-items", body, H()).then(r => r.data),
  updateMenuItem: (id, body)     => api.patch(`/fnb/v1/menu-items/${id}`, body, H()).then(r => r.data),
  tables:       ()               => api.get("/fnb/v1/tables", H()).then(r => r.data),
  createTable:  (body)           => api.post("/fnb/v1/tables", body, H()).then(r => r.data),
  updateTable:  (id, body)       => api.patch(`/fnb/v1/tables/${id}`, body, H()).then(r => r.data),
  deleteTable:  (id)             => api.delete(`/fnb/v1/tables/${id}`, H()).then(r => r.data),
  orders:       (params={})      => api.get("/fnb/v1/orders", { ...H(), params }).then(r => r.data),
  order:        (id)             => api.get(`/fnb/v1/orders/${id}`, H()).then(r => r.data),
  createOrder:  (body)           => api.post("/fnb/v1/orders", body, H()).then(r => r.data),
  addLines:     (id, lines)      => api.post(`/fnb/v1/orders/${id}/lines`, { lines }, H()).then(r => r.data),
  voidOrder:    (id, reason)     => api.post(`/fnb/v1/orders/${id}/void`, { reason }, H()).then(r => r.data),
  moveOrder:    (id, table_id)   => api.post(`/fnb/v1/orders/${id}/move`, { table_id }, H()).then(r => r.data),
  closeOrder:   (id, body)       => api.post(`/fnb/v1/orders/${id}/close`, body, H()).then(r => r.data),
  tickets:      (params={})      => api.get("/fnb/v1/tickets", { ...H(), params }).then(r => r.data),
  setLineStatus:(tid, lid, status) => api.post(`/fnb/v1/tickets/${tid}/lines/${lid}/status`, { status }, H()).then(r => r.data),
  breakfast:    (params={})      => api.get("/fnb/v1/breakfast", { ...H(), params }).then(r => r.data),
  serveBreakfast:(body)          => api.post("/fnb/v1/breakfast/serve", body, H()).then(r => r.data),
  walkinSearch: (q)              => api.get("/fnb/v1/breakfast/walkin/search", { ...H(), params: { q } }).then(r => r.data),
  walkinServe:  (body)           => api.post("/fnb/v1/breakfast/walkin/serve", body, H()).then(r => r.data),
  breakfastDiagnostic: (rid_or_code) => api.get(`/fnb/v1/reservations/${encodeURIComponent(rid_or_code)}/breakfast-diagnostic`, H()).then(r => r.data),
  repairBreakfast:     (rid_or_code) => api.post(`/fnb/v1/reservations/${encodeURIComponent(rid_or_code)}/repair-breakfast`, {}, H()).then(r => r.data),
  revenue:      (params={})      => api.get("/fnb/v1/reports/revenue", { ...H(), params }).then(r => r.data),
  patchStayBenefits: (rid, body) => api.patch(`/fnb/v1/reservations/${rid}/stay-benefits`, body, H()).then(r => r.data),
};

export const fmtINR = (n) => {
  const v = Number(n || 0);
  if (!isFinite(v)) return "₹0";
  return "₹" + v.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
export const fmtINRshort = (n) => {
  const v = Number(n || 0);
  if (v >= 1e7) return "₹" + (v/1e7).toFixed(2) + "Cr";
  if (v >= 1e5) return "₹" + (v/1e5).toFixed(2) + "L";
  if (v >= 1e3) return "₹" + (v/1e3).toFixed(1) + "k";
  return "₹" + v.toFixed(0);
};
export const fmtDate = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }); }
  catch { return iso; }
};

export const TABLE_STATUS_STYLE = {
  available:     { chip: "bg-emerald-500/15 text-emerald-700 ring-emerald-500/25", dot: "bg-emerald-500", label: "Available" },
  occupied:      { chip: "bg-sky-500/15 text-sky-700 ring-sky-500/25",             dot: "bg-sky-500",     label: "Occupied" },
  reserved:      { chip: "bg-violet-500/15 text-violet-700 ring-violet-500/25",     dot: "bg-violet-500",  label: "Reserved" },
  cleaning:      { chip: "bg-amber-500/15 text-amber-700 ring-amber-500/25",       dot: "bg-amber-500",   label: "Cleaning" },
  waiting_bill:  { chip: "bg-rose-500/15 text-rose-700 ring-rose-500/25",           dot: "bg-rose-500",    label: "Waiting Bill" },
  blocked:       { chip: "bg-slate-500/15 text-slate-700 ring-slate-500/25",       dot: "bg-slate-400",   label: "Blocked" },
};

export const LINE_STATUS_STYLE = {
  new:       { chip: "bg-slate-100 text-slate-700",     label: "New" },
  accepted:  { chip: "bg-sky-100 text-sky-700",         label: "Accepted" },
  preparing: { chip: "bg-amber-100 text-amber-700",     label: "Preparing" },
  ready:     { chip: "bg-emerald-100 text-emerald-700", label: "Ready" },
  served:    { chip: "bg-emerald-500 text-white",       label: "Served" },
  cancelled: { chip: "bg-rose-100 text-rose-700",       label: "Cancelled" },
};
